interface IProps {
  readonly onClick: TVoidCallback
}

/**
 * Modal és Alert komponensek bezárógombja.
 * @param props - JSX props {@link IProps}.
 */
export default function CloseButton (props: IProps): HTMLElement {
  const btn: HTMLElement = (
    <button className="btn-close" aria-label="Close" type="button" { ...props } />
  )

  return btn
}
